import { useBreakpoint } from '@pelckmans/elementis/contexts/BreakpointsContext';
import classNames from 'classnames';
import { useContext, useEffect, useMemo, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import SidebarVisibilityContext from '../pages/material/_contexts/SidebarVisibilityContext';
import ContentActionBar from './content/ContentActionBar';
import ContentFooter from './content/ContentFooter';
import Footer from './footer/Footer';
import ApplicationNavigation from './navigation/page-level/ApplicationNavigation';
import PageNavigation from './navigation/page-level/PageNavigation';
import MaterialSidebar from './sidebar/MaterialSidebar.ianua';

export default function PageLevelLayout() {
  const { nodeId, selectedModuleSlug } = useParams();
  const breakpoint = useBreakpoint();

  const { isSidebarVisible: sidebarVisible, setSidebarVisibility } = useContext(SidebarVisibilityContext);

  const isSidebarVisible = useMemo(() => {
    if (!selectedModuleSlug) return false;

    if (breakpoint === 'desktop') return true;

    if (!nodeId) return true;

    return sidebarVisible;
  }, [breakpoint, nodeId, selectedModuleSlug, sidebarVisible]);

  const [overview, setOverviewMode] = useState(!nodeId ? true : false);
  const [animateSidebar, setAnimateSidebar] = useState(overview);

  useEffect(() => {
    if (!overview && animateSidebar) {
      setTimeout(() => setAnimateSidebar(overview), 240);

      return;
    }

    if (overview !== animateSidebar) {
      setAnimateSidebar(overview);
    }
  }, [overview, animateSidebar]);

  useEffect(() => {
    if (['tablet', 'mobile'].includes(breakpoint)) {
      setSidebarVisibility(false);
    } else {
      setOverviewMode(!nodeId ? true : false);
    }
  }, [breakpoint, nodeId, setSidebarVisibility]);

  const showOverview = overview || ['tablet', 'mobile'].includes(breakpoint);

  return (
    <div
      className={classNames('page', 'material-page', {
        'material-page-with-sidebar': isSidebarVisible,
        'sidebar--expanded': isSidebarVisible && animateSidebar,
      })}
    >
      {breakpoint !== 'mobile' && <PageNavigation />}
      <div className="page-content">
        {breakpoint === 'mobile' && <ApplicationNavigation />}
        <div className="main-layout">
          <div className="main-layout-container">
            {isSidebarVisible && (
              <div className="sidebar-layout">
                <MaterialSidebar overview={showOverview} setOverviewMode={setOverviewMode} />
              </div>
            )}
            <div className="content-layout">
              <main>
                <div className="margin-wrapper">
                  <Outlet />
                  <ContentActionBar>
                    <div id="action-bar" />
                  </ContentActionBar>
                  <ContentFooter>
                    <Footer />
                  </ContentFooter>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
